import { createTheme } from "@mui/material";

export const ScienceFairTheme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#e23840",
    },
  },
});
